var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket-detail" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("customerService.ticket_details"),
            visible: _vm.dialogTableVisible,
            width: "580px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogTableVisible = $event
            },
            open: _vm.getDetailInfo,
          },
        },
        [
          _c("div", { staticClass: "item", staticStyle: { margin: "0" } }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.business_type"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                _vm._s(_vm.getBusinessTypeLabel(_vm.ticketInfo.operation_type))
              ),
            ]),
          ]),
          _vm.ticketInfo.merchant_order_id
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(_vm._s(_vm.$t("customerService.merchant_order_id"))),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(" " + _vm._s(_vm.ticketInfo.merchant_order_id)),
                ]),
              ])
            : _vm._e(),
          _vm.ticketInfo.refund_amount
            ? _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "item-left content-blue" }, [
                  _vm._v(
                    _vm._s(_vm.$t("customerService.request_refund_amount"))
                  ),
                ]),
                _c("span", { staticClass: "content-gray" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("toDivideWithDot")(_vm.ticketInfo.refund_amount)
                      )
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("dashboard.transaction_amount"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                " " + _vm._s(_vm._f("toDivideWithDot")(_vm.ticketInfo.amount))
              ),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(" " + _vm._s(_vm.$t("components.transaction_date"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(" " + _vm._s(_vm.ticketInfo.transaction_date)),
            ]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("customerService.customer_phone_number"))
              ),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm._f("strAesDecryptAndAsterisk")(_vm.ticketInfo.phone_no)
                  )
              ),
            ]),
          ]),
          _c("div", { staticClass: "section-title  mb-12 mt-24" }, [
            _vm._v(" " + _vm._s(_vm.$t("customerService.other_details")) + " "),
          ]),
          _c("div", { staticClass: "line-bottom-1px" }),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(_vm._s(_vm.$t("customerService.description"))),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.ticketInfo.issue)),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "item" },
            [
              _c("span", { staticClass: "item-left content-blue" }, [
                _vm._v(" " + _vm._s(_vm.$t("customerService.attachments"))),
              ]),
              _vm._l(_vm.ticketInfo.attachmentsList, function (fileName) {
                return _c(
                  "span",
                  {
                    key: fileName,
                    staticClass: "content-file",
                    on: {
                      click: function ($event) {
                        return _vm.onClickFileName(fileName)
                      },
                    },
                  },
                  [_vm._v(_vm._s(fileName))]
                )
              }),
            ],
            2
          ),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(" " + _vm._s(_vm.$t("customerService.payment_receipt"))),
            ]),
            _vm.ticketInfo.pic_path
              ? _c("img", {
                  directives: [{ name: "viewer", rawName: "v-viewer" }],
                  staticClass: "content-img",
                  attrs: { src: _vm.ticketInfo.pic_path },
                })
              : _vm._e(),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("span", { staticClass: "item-left content-blue" }, [
              _vm._v(" " + _vm._s(_vm.$t("customerService.conclusion")) + " "),
            ]),
            _c("span", { staticClass: "content-gray" }, [
              _vm._v(_vm._s(_vm.ticketInfo.conclusion)),
            ]),
          ]),
          _c(
            "el-tag",
            {
              staticClass: "tag-custom payin-status",
              attrs: { type: _vm.getTicketStatusStyle(_vm.ticketInfo.status) },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.getTicketStatusLabel(_vm.ticketInfo.status))
              ),
            ]
          ),
          _c("div", { staticClass: "btn-container" }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogImageVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogImageVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }